import React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectFeatureBehaviorFromBootstrap, selectGeoFromBootstrap } from 'store/slice/bootstrap';
import { setTravelDateInSearchBoxSettingsStateFromQueryParams, selectTextForTextSearch, setTextSearchInSearchBoxSettingsState } from 'store/slice/home';
import { OverlayType, showOverlay } from 'store/slice/overlay';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Category, SuggestionResult } from 'core/type/SuggestionResult.types';
import { getSearchPageUrlFromGlobalKeyword, getSearchPageUrl } from 'core/utils/activityUrlGenerator';
import { routeTo } from 'store/slice/navigation';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';

interface OwnProps {
    pageTypeId: number;
    query: string;
    onSearchButtonClick: () => void;
    setSearchText: React.Dispatch<React.SetStateAction<string>>;
    setSelectedResult: (selected?: SuggestionResult) => void;
    selected?: SuggestionResult;
    inputRef?: React.RefObject<HTMLInputElement>;
    placeholderText: string;
}

interface StateProps {
    cms: CmsValue;
    searchText: string;
    isSearchBoxDropdown: boolean;
    screenSize: ScreenSize;
    isGlobalKeywordSearch: boolean;
    suggestionResult?: SuggestionResult;
}

interface DispatchProps {
    showOverlay: (overlayType: OverlayType) => void;
    onLocationSearchChange: (locationSearch: string) => void;
    onSearchResultSelect: (result: SuggestionResult, category?: Category) => void;
    onGlobalKeywordResultSelect: (keyword: string) => void;
}

export type SearchBoxPickerProps = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectGeoFromBootstrap,
    selectTextForTextSearch,
    selectScreenSize,
    selectFeatureBehaviorFromBootstrap,
    (cms, geo, searchText, screenSize, featureBehaviours): StateProps => {
        const isSearchBoxDropdown = featureBehaviours.SearchBoxPopOverFeature;
        const isGlobalKeywordSearch = featureBehaviours.GlobalKeywordSearch;
        return { cms, searchText, isSearchBoxDropdown, screenSize, isGlobalKeywordSearch, suggestionResult: geo };
    },
);

export const mapDispatchToProps = (dispatch: Function): DispatchProps => {
    return {
        showOverlay: (overlayType: OverlayType) => {
            dispatch(showOverlay(overlayType));
        },
        onLocationSearchChange: (locationSearch: string) => {
            dispatch(setTravelDateInSearchBoxSettingsStateFromQueryParams({ locationSearch }));
        },
        onSearchResultSelect: (suggestion?: SuggestionResult, category?: Category) => {
            if (!suggestion) return;
            const searchPageUrl = getSearchPageUrl(suggestion, undefined, category);
            dispatch(setTextSearchInSearchBoxSettingsState(suggestion));
            dispatch(routeTo(searchPageUrl));
        },
        onGlobalKeywordResultSelect: (keyword: string) => {
            const searchPageUrl = getSearchPageUrlFromGlobalKeyword(keyword);
            dispatch(routeTo(searchPageUrl));
        },
    };
};
